import React from "react";

export default ({
  t,
  leftText = "",
  rightText = null,
  showButton = false,
  styleClass,
}) => {
  if (!rightText) {
    return null;
  }
  return (
    <>
      <div className="result-row">
        <div className="left-container">{leftText}</div>
        <div className="middle-container" />
        <div className="right-container">
          <div style={styleClass}>{rightText}</div>
        </div>
      </div>
      {showButton && (
        <div className="book-appointment-button-container">
          <button type="button" className="book-appointment-button">
            {t("BOOK_NEXT_APPOINTMENT")}
          </button>
        </div>
      )}
    </>
  );
};
